export const navTranslations = {
  en: {
    home: 'Home',
    study: 'Study',
    quizzes: 'Tests',
    login: 'Login',
    signup: 'Sign Up',
    logout: 'Logout',
    account: 'Account',
    logoText: 'Learning'
  },
  vi: {
    home: 'Trang chủ',
    study: 'Học',
    quizzes: 'Bài kiểm tra',
    login: 'Đăng nhập',
    signup: 'Đăng ký',
    logout: 'Đăng xuất',
    account: 'Tài khoản',
    logoText: 'Học tập'
  }
};